import { RootState } from 'store';
import { UnitState } from 'types/time-registration-policy/ITimeRegistrationPolicy';

export const policyUnitsSelector = (state: RootState): UnitState[] => state.timeRegistrationPolicy.units;
export const policyLoadingSelector = (state: RootState): boolean => state.timeRegistrationPolicy.loading;
export const policyLoadErrorSelector = (state: RootState): boolean => state.timeRegistrationPolicy.loadError;
